import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import React, { Component } from "react";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button, Card,
  CardBody,
  CardTitle, Col, FormGroup,
  Label
} from "reactstrap";
//Import actions redux
import { registerUser } from "../../store/actions";

const roles = [ 
  {name : "Experto", value: 1}, 
  {name : "Administrador", value: 2}, 
  {name : "Usuario almacén", value: 3}
]

class CreateUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      popup: false,
      pop_msg: ""
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingCreateUser === false &&
      prevProps.loadingCreateUser === true
    ) {
      let msg = this.props.message;
      let err = this.props.registrationError;
      if (msg) {
        this.setState({
          popup: true,
          pop_msg: "Usuario creado correctamente", 
        });
      }
      else if(err){
        this.setState({
          popup: true,
          pop_msg: "Error al crear el usuario",
        });
      }
    }
  } //Falta loader de carga mientras se genera el usuario

  // handleValidSubmit
  handleValidSubmit(event, values) {
    let user = this.state.user;
    values["username"] = user.name;
    values["token"] = user.token
    this.props.registerUser(values, this.props.history);
  }

  confirmPopup() {
    this.setState({ popup: false });
    this.props.history.push("/users");
  }

  render() {
    let user = this.state.user
    return (
      <React.Fragment>
        <Col lg="12">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">
                {this.props.t("Crear nuevo usuario")}
              </CardTitle>

              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidSubmit}
              >
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom01">Nombre de usuario</Label>
                    <AvField
                      name="name"
                      placeholder="Username"
                      type="text"
                      errorMessage="Enter Username"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom01"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom02">Contraseña</Label>
                    <AvField
                      name="pass"
                      placeholder="Password"
                      type="password"
                      errorMessage="Enter Password"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                    <Label htmlFor="validationCustom05">Rol</Label>
                      <AvInput
                        value={roles[0].value}
                        name="role_id"
                        placeholder="Role"
                        type="select"
                        errorMessage="Please provide a valid role."
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="validationCustom09"
                      >
                         {roles.map((role, key) => (
                           role.value >= user.role_id && (
                            <option key={key} value= {role.value}>{role.name}</option>
                           )
                        ))}
                      </AvInput>
                    </FormGroup>
                  </Col>
                <Button color="primary" type="submit">
                {this.props.t('Crear usuario')}
                </Button>
              </AvForm>
              { this.state.popup ? (
             
                <SweetAlert
                type={this.state.pop_msg ? "success" : "error"}
                title={
                  this.state.pop_msg ? this.state.pop_msg : this.state.pop_err
                }
                confirmBtnText={this.props.t("ok")}
                
                onConfirm={() => this.confirmPopup()}
                ></SweetAlert>
              ) : null}
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const { registrationError, message, loadingCreateUser } = state.Account;
  return { registrationError, message, loadingCreateUser };
};
export default withRouter(
  connect(mapStateprops, {registerUser})(withNamespaces()(CreateUserForm))
);
